import { css } from "@emotion/react";

import React from "react";

import Header from "./Header";
import Navigation from "./Navigation";

function Layout({ padding = true, screen, children }) {
  return (
    <div css={layout}>
      <Header />
      <Navigation />
      <div css={main}>
        <div css={content(padding, screen)}>{children}</div>
      </div>
    </div>
  );
}

const layout = (theme) => css``;

const main = (theme) => css`
  position: relative;
  padding: 60px 0 0 220px;
  background: #f8f8f8;
  min-width: 1900px;
  min-height: 100vh;
`;

const content = (padding, screen) => (theme) =>
  css`
    position: relative;
    padding: ${padding ? 30 : 0}px;
    ${screen &&
    css`
      min-height: calc(100vh - 60px);
    `}
  `;

export default React.memo(Layout);
